// extracted by mini-css-extract-plugin
export var container = "_4i-0";
export var error = "_4i-9";
export var label = "_4i-5";
export var light = "_4i-6";
export var md = "_4i-3";
export var sm = "_4i-2";
export var thin = "_4i-8";
export var thinBold = "_4i-7";
export var vertical = "_4i-4";
export var xs = "_4i-1";